import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Course } from 'src/app/models/course.model';
import { RegistryImageVersion } from 'src/app/models/registry-image-version.model';
import { EditAppServerDialogComponent } from '../edit-app-server-dialog/edit-app-server-dialog.component';
import { MatSnackBar } from '@angular/material/snack-bar';
import { InfoPopUpComponent } from '../../pop-ups/info-pop-up/info-pop-up.component';
import { PopupHelper } from '../../../helpers/pop-up-helper';
import { Bundle } from 'src/app/models/bundle.model';

@Component({
  selector: 'app-edit-course-dialog',
  templateUrl: './edit-course-dialog.component.html',
  styleUrls: ['./edit-course-dialog.component.scss']
})
export class EditCourseDialogComponent implements OnInit {
  public editCourseForm: UntypedFormGroup;
  public minorVersions: string[];
  public majorVersions: string[];
  public majorVersionsWiithBuilds: RegistryImageVersion[];
  public bundles: Bundle[];
  public courseToEdit: Course;

  
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: {
      minorVersions: string[],
      majorVersions: string[],
      majorVersionsWiithBuilds: RegistryImageVersion[],
      courseToEdit: Course
      bundles: Bundle[];
    },
    private dialogRef: MatDialogRef<EditAppServerDialogComponent>,
    private popUp: MatSnackBar,
    private popUpHelper: PopupHelper
  ) { 
    this.minorVersions = data.minorVersions;
    this.majorVersions = data.majorVersions;
    this.majorVersionsWiithBuilds = data.majorVersionsWiithBuilds;
    this.courseToEdit = data.courseToEdit;
    this.bundles = data.bundles;
  }

  ngOnInit(): void {
    this.editCourseForm = new UntypedFormGroup({
      courseName: new UntypedFormControl(this.courseToEdit.courseName, Validators.required),
      gitUrl: new UntypedFormControl(this.courseToEdit.gitURL, Validators.required),
      majorVersion: new UntypedFormControl(this.courseToEdit.majorVersion, Validators.required),
      minorVersion: new UntypedFormControl('', Validators.required),
      vcs: new UntypedFormControl(this.courseToEdit.vcs, Validators.required),
      bundle: new UntypedFormControl(this.courseToEdit.bundleDto.bundleName, Validators.required)
    })
    this.onVersionChange(this.courseToEdit.majorVersion);
    this.editCourseForm.get('minorVersion').setValue(this.courseToEdit.minorVersion);
  }

  onVersionChange(selectedVersion) {
    this.minorVersions = this.majorVersionsWiithBuilds.filter(version =>
        version.majorVersion === selectedVersion)[0].minorVersions.map(build => build.name);
    this.minorVersions.sort((a, b) => b.localeCompare(a, undefined, {numeric: true, sensitivity: 'base'}));
    this.editCourseForm.get('minorVersion').setValue(this.minorVersions[0]);
    this.editCourseForm.get('minorVersion').enable();
  }

  errorHandling(control: string, error: string) {  
    return this.editCourseForm.controls[control].hasError(error);
  }

  disableConfirm() {
    return !this.editCourseForm.valid;
  }

  submitDialog() {
    const formValues = this.editCourseForm.value;
    const original = this.courseToEdit;
    const newBundle = this.bundles.find(o => o.bundleName === formValues.bundle);

    const coursePatch: Partial<Course> = {
      courseID: original.courseID,
      courseName: formValues.courseName,
      gitURL: formValues.gitUrl,
      majorVersion: formValues.majorVersion,
      minorVersion: formValues.minorVersion,
      vcs: formValues.vcs,
      bundleDto: newBundle
    };

    const changed = Object.entries(coursePatch).some(([key, value]) =>
      key !== 'courseID' && value !== (this.courseToEdit as any)[key]
    );

    if (!changed) {
      this.popUpHelper.showErrorPopUp('No changes were made.');
      return;
    }

    for (const key in coursePatch) {
      if (key !== 'courseID' && coursePatch[key] === this.courseToEdit[key]) {
        coursePatch[key] = null;
      }
    }

    this.dialogRef.close(coursePatch);
  }

}
